export const SET_ACTIVITY_FEED_STATE_METHOD = 'InteractionInterface.v1_0.SetActivityFeedStateMethod';
